export enum LikeEntity {
  NFT = "nft",
  POST = "post",
  NFT_COMMENT = "nft-comment",
  POST_COMMENT = "post-comment",
}
